import Modal from './containers/Modal'

export default Modal
